import * as NotificationAction from "../notificationReducer";
import BdBeService from "../../services/10BdBe-service";

export const GET_SEND_EMAILS_LIST = 'GET_SEND_EMAILS_LIST';
export const GET_SEND_EMAILS_LIST_SUCCESS = 'GET_SEND_EMAILS_LIST_SUCCESS';
export const GET_SEND_EMAILS_LIST_FAIL = 'GET_SEND_EMAILS_LIST_FAIL';

export const ADMIN_10BDBE_EMAILS_LIST_RESET = 'ADMIN_10BDBE_EMAILS_LIST_RESET';

export const CHANGE_ADMIN_10BDBE_NONPROFITS = 'CHANGE_ADMIN_10BDBE_NONPROFITS'
export const CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS = 'CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS'
export const CHANGE_ADMIN_10BDBE_NONPROFITS_FAIL = 'CHANGE_ADMIN_10BDBE_NONPROFITS_FAIL'
export const GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL = 'GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL';

const initialState = {
  emails10BdBe: [],
  nonprofit_count: 0,
};

export const admin10BdBeEmailsListReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_SEND_EMAILS_LIST:
      return {
        ...state,
      };

    case GET_SEND_EMAILS_LIST_SUCCESS:
      return {
        ...state,
        emails10BdBe: action.emails,
        nonprofit_count: action.count
      };
    case GET_SEND_EMAILS_LIST_FAIL:
      return {
        ...state,
      };

    case ADMIN_10BDBE_EMAILS_LIST_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};


export function getSendEmailsList({ ...query }) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_SEND_EMAILS_LIST,
    });
    const { q, status } = query || {}
    const currentNonprofits = getState().admin10BdBeEmailsList.emails10BdBe;
    const isQuerySearch = (q && q.length > 0)
    const params = {
      limit: 10,
      skip: currentNonprofits.length,
      ...query,
    }

    return BdBeService.get10BESendEmailsList({ isQuerySearch }, { params })
      .then((response) => {
        if (status === '') {
          dispatch({
            type: GET_SEND_EMAILS_LIST_SUCCESS,
            emails: response.data,
            load_status: true,
            count: response?.total_users
          });
        }
        else {
          const fres = response?.data;
          if (fres.length === 0) {
            dispatch({
              type: GET_SEND_EMAILS_LIST_SUCCESS,
              emails: [],
              load_status: false,
            });
          } else {
            dispatch({
              type: GET_SEND_EMAILS_LIST_SUCCESS,
              emails: currentNonprofits && currentNonprofits.length ? [...currentNonprofits, ...fres] : [...fres],
              load_status: true,
              count: response?.total_users
            });
          }
          return fres;
        }
        return response
      })
      .catch((error) => {
        dispatch({
          type: GET_SEND_EMAILS_LIST_FAIL,
        });
        dispatch(NotificationAction.addNotification(error.message));
      });
  };
}

export function sendEmailNonprofits(userPANs, {...params}) {
  const payload = {
    userPANs,
    ...params
  };
  return (dispatch) => {
    dispatch({
      type: CHANGE_ADMIN_10BDBE_NONPROFITS,
    });
    return BdBeService.set({ isSendEmail: true, ...payload })
      .then((response) => {
        if (response) {
          dispatch({
            type: CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS,
          });
          dispatch(NotificationAction.addNotification('Email sent successfully', 'SUCCESS'));

        } else {
          dispatch({
            type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch({
          type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
        });
        dispatch(NotificationAction.addNotification(error.message));
      });
  };
}

export function reset() {
  return (dispatch) => {
    dispatch({
      type: ADMIN_10BDBE_EMAILS_LIST_RESET,
    });
  };
}